import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Globals} from "../global/globals";
import {Observable} from "rxjs";
import {WorkflowStepLibraryQubitModel} from "../models/workflow-step/workflow-step-library-qubit.model";
import {WorkflowStep} from "../enums/WorkflowStep";

@Injectable({
  providedIn: 'root'
})
export class WorkflowInstanceStepLibraryQualityAssuranceQubitService {

  private readonly baseUri: string;

  constructor(private http: HttpClient,
              private globals: Globals) {
    this.baseUri = globals.backendUri + '/workflow-instance-steps/library-quality-assurance-qubit';
  }

  /**
   * Calculates the dilution and AD values for the given concentrations
   *
   * @param workflowStep The workflow step containing the concentrations to calculate
   * @returns An observable of the updated workflow step with calculated values
   */
  calculateVolumes(workflowStep: WorkflowStepLibraryQubitModel): Observable<WorkflowStepLibraryQubitModel> {
    // Create a DTO object that matches the expected backend format
    const dto = {
      workflowInstanceId: workflowStep.workflowInstance?.id,
      workflow: workflowStep.workflowInstance?.workflow,
      workflowInstanceStepId: workflowStep.id,
      workflowStep: WorkflowStep.QUALITY_ASSURANCE_QUBIT,
      batches: workflowStep.batches,
      volumeForFourNmPool: workflowStep.volumeForFourNmPool,
      targetConcentration: workflowStep.targetConcentration,
      indexPoolsCombined: workflowStep.indexPoolsCombined,
      concentrations: workflowStep.concentrations.map(c => ({
        id: c.id,
        concentration: c.concentration,
        concentration1: c.concentration1,
        concentration2: c.concentration2
      }))
    };

    return this.http.post<WorkflowStepLibraryQubitModel>(`${this.baseUri}/calculate-volumes`, dto);
  }
}
